"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRadioGroup = exports.StyledRadio = exports.StyledLabel = exports.StyledContainer = exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledLabel = exports.StyledLabel = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-xlx4mh-0"
})(["font-size:", ";font-weight:", ";line-height:", ";"], function (props) {
  return props.$theme.radio.label.fontSize;
}, function (props) {
  return props.$theme.radio.label.fontWeight;
}, function (props) {
  return props.$theme.radio.label.lineHeight;
});
var radioEffect = (0, _ykbStyledComponents.keyframes)(["0%{transform:scale(1);opacity:0.5;}100%{transform:scale(1.6);opacity:0;}"]);
var Container = exports.Container = function Container(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    checked = _ref.checked,
    disabled = _ref.disabled,
    selectionBox = _ref.selectionBox,
    style = _ref.style,
    cls = _ref.cls,
    vertical = _ref.vertical;
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(StyledRadio, {
    theme: theme,
    prefixCls: prefix,
    checked: checked,
    disabled: disabled,
    selectionBox: selectionBox,
    style: style,
    className: cls,
    vertical: vertical
  }, children(prefix));
};
var StyledRadio = exports.StyledRadio = _ykbStyledComponents.default.label.withConfig({
  componentId: "ykb-ui__sc-xlx4mh-1"
})(["", " display:inline-block;", " position:relative;white-space:nowrap;margin-right:", ";cursor:pointer;&:hover .", "{visibility:visible;}&:hover{.", "-inner{border-color:", ";}}.", "{", " white-space:nowrap;outline:none;display:inline-block;position:relative;line-height:1;vertical-align:top;cursor:pointer;vertical-align:text-bottom;&:hover,&-focused{.", "-inner{border-color:", ";}}&-checked:after{position:absolute;top:0;left:0;width:100%;height:100%;border-radius:50%;border:1px solid ", ";content:'';animation:", " 0.36s ease-in-out;animation-fill-mode:both;visibility:hidden;}&:hover:after{visibility:visible;}&-inner{&:after{position:absolute;width:", ";height:", ";left:", "px;top:", "px;border-radius:100%;border-top:0;border-left:0;content:' ';background-color:", ";opacity:0;transform:scale(0);transition:all ", ";}background:", ";position:relative;top:0;left:0;display:block;width:", ";height:", ";border-width:1px;border-style:solid;border-radius:100%;border-color:", ";transition:all ", ";}&-input{position:absolute;left:0;z-index:1;cursor:pointer;opacity:0;top:0;bottom:0;right:0;&:focus + .", "-inner{border-color:", ";", ";}}", ";", ";& + ", "{padding-left:", ";padding-right:", ";}}", ""], function (props) {
  return props.theme.mixins.resetComponent(_ykbStyledComponents.css);
}, function (props) {
  return props.vertical && (0, _ykbStyledComponents.css)(["display:table;margin-bottom:10px;"]);
}, function (props) {
  return props.theme.radio.labelMargin;
}, function (props) {
  return props.prefixCls + ':after';
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.radio.inputHoverBorderColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.mixins.resetComponent(_ykbStyledComponents.css);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.radio.inputHoverBorderColor;
}, function (props) {
  return props.theme.radio.checkColor;
}, radioEffect, function (props) {
  return props.theme.radio.circleDotSize;
}, function (props) {
  return props.theme.radio.circleDotSize;
}, function (props) {
  return (parseInt(props.theme.radio.circleSize) - parseInt(props.theme.radio.circleDotSize)) / 2 - 1;
}, function (props) {
  return (parseInt(props.theme.radio.circleSize) - parseInt(props.theme.radio.circleDotSize)) / 2 - 1;
}, function (props) {
  return props.theme.radio.checkColor;
}, function (props) {
  return props.theme.radio.transitionDuration;
}, function (props) {
  return props.theme.radio.radioInnerBackgroundColor;
}, function (props) {
  return props.theme.radio.circleSize;
}, function (props) {
  return props.theme.radio.circleSize;
}, function (props) {
  return props.theme.radio.borderColor;
}, function (props) {
  return props.theme.radio.transitionDuration;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.radio.inputHoverBorderColor;
}, function (props) {
  return !props.checked && (0, _ykbStyledComponents.css)(["box-shadow:", ";"], function (props) {
    return props.theme.radio.focusBoxShadow;
  });
}, function (props) {
  return props.checked && (0, _ykbStyledComponents.css)([".", "-inner{border-color:", ";&:after{transform:scale(1);opacity:1;transition:all ", " ease-in-out;}}"], function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.radio.borderColor;
  }, function (props) {
    return props.theme.radio.transitionDuration;
  });
}, function (props) {
  return props.disabled && (0, _ykbStyledComponents.css)([".", "-inner{border-color:", " !important;background-color:", ";&:after{background-color:", ";}}.", "-input{cursor:not-allowed;}& + ", "{color:", ";cursor:not-allowed;}"], function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.radio.borderColor;
  }, function (props) {
    return props.theme.radio.inputDisabledBackground;
  }, function (props) {
    return props.theme.radio.textColorDisabled;
  }, function (props) {
    return props.prefixCls;
  }, StyledLabel, function (props) {
    return props.theme.radio.textColorDisabled;
  });
}, StyledLabel, function (props) {
  return props.theme.radio.labelPadding;
}, function (props) {
  return props.theme.radio.labelPadding;
}, function (props) {
  return props.selectionBox && (0, _ykbStyledComponents.css)(["padding:", ";margin-bottom:", ";border:1px solid ", ";border-radius:", ";width:100%;display:table;table-layout:fixed;overflow:hidden;", " &:hover{border-color:", ";}.", "{display:table-cell;z-index:10;padding:0px;width:", ";white-space:nowrap;vertical-align:middle;line-height:1;}", "{display:table-cell;width:100%;margin-bottom:0;height:100%;overflow:hidden;text-overflow:ellipsis;vertical-align:middle;}"], function (props) {
    return props.theme.radio.selectionBox.componentPadding;
  }, function (props) {
    return props.theme.radio.selectionBox.componentPadding;
  }, function (props) {
    return props.theme.radio.borderColor;
  }, function (props) {
    return props.theme.radio.borderRadiusBase;
  }, function (props) {
    return props.disabled && (0, _ykbStyledComponents.css)(["background-color:", ";&:hover{border-color:", " !important;}"], function (props) {
      return props.theme.radio.inputDisabledBackground;
    }, function (props) {
      return props.theme.radio.borderColor;
    });
  }, function (props) {
    return props.theme.radio.inputHoverBorderColor;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.radio.circleSize;
  }, StyledLabel);
});
var StyledRadioGroup = exports.StyledRadioGroup = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-xlx4mh-2"
})(["&[disabled='true']{cursor:not-allowed;", "{pointer-events:none;> span:first-child{> span[class*='-inner']{border-color:", " !important;background-color:", ";&:after{background-color:", ";}}input[class*='-input']{cursor:not-allowed;}& + span{color:", ";cursor:not-allowed;}}}}"], StyledRadio, function (props) {
  return props.theme.radio.borderColor;
}, function (props) {
  return props.theme.radio.inputDisabledBackground;
}, function (props) {
  return props.theme.radio.textColorDisabled;
}, function (props) {
  return props.theme.radio.textColorDisabled;
});
var StyledContainer = exports.StyledContainer = (0, _ykbStyledComponents.default)(Container).withConfig({
  componentId: "ykb-ui__sc-xlx4mh-3"
})([""]);